import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  GeckoModalService,
  GeckoFields,
  GeckoIcon,
  GeckoBtnsSorted,
} from '../../';
import { GeckoFieldsModel, GeckoBtnsModel } from '../../models';
import './modal.scss';

class GeckoModal extends Component {
  close() {
    return new GeckoModalService().close();
  }

  renderHeader() {
    if (this.props.name) {
      return (
        <div className="modal-header">
          <h4 id={`${this.props.id}-header`} className="modal-title">
            {this.props.name}
          </h4>
          <span
            className="modal-close"
            aria-label="Close"
            onClick={this.close.bind(this)}
          >
            <GeckoIcon icon="far fa-times" />
          </span>
        </div>
      );
    }
    return null;
  }

  renderBody() {
    return (
      <div className="modal-body clearfix">
        {this.props.children}

        {this.renderFields()}
      </div>
    );
  }

  renderFields() {
    if (this.props.fields.length) {
      return (
        <GeckoFields
          fields={this.props.fields}
          values={this.props.values}
          handler={this.props.handler.bind(this)}
          submitHandler={this.props.submitHandler}
        />
      );
    }
    return null;
  }

  renderFooter() {
    if (this.props.btns.length) {
      return (
        <div className="modal-footer">
          <GeckoBtnsSorted items={this.props.btns} />
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <div
        id={this.props.id}
        className="gecko-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={`${this.props.id}-header`}
      >
        {this.renderHeader()}

        {this.renderBody()}

        {this.renderFooter()}
      </div>
    );
  }
}

GeckoModal.defaultProps = {
  fields: [],
  values: {},
  handler: () => {},
  submitHandler: () => {},
  btns: [],
};

GeckoModal.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  fields: GeckoFieldsModel,
  values: PropTypes.object,
  handler: PropTypes.func,
  submitHandler: PropTypes.func,
  btns: GeckoBtnsModel,
};

export default GeckoModal;
